import React from 'react'

export default function FormField({
  label,
  name,
  type = 'text',
  defaultValue,
  value,
  onChange,
  placeholder,
  error,
  helpText,
  required = false,
  className = '',
  inputClassName = '',
  as = 'input',
  ...props
}) {
  const inputClasses = `w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light ${inputClassName}`
  const isControlled = value !== undefined

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      {as === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          {...(isControlled ? { value, onChange } : { defaultValue })}
          placeholder={placeholder}
          className={inputClasses}
          rows={4}
          {...props}
        />
      ) : (
        <input
          type={type}
          id={name}
          name={name}
          {...(isControlled ? { value, onChange } : { defaultValue })}
          placeholder={placeholder}
          className={inputClasses}
          {...props}
        />
      )}

      {helpText && (
        <p className="mt-1 text-gray-500 text-sm">{helpText}</p>
      )}

      {error && (
        <div className="mt-1 text-red-600 text-sm">{error}</div>
      )}
    </div>
  )
}
